import React from "react"
import { 
  Button, 
  OverlayTrigger,
  Tooltip
} from "react-bootstrap"
import {
  HiDocument,
  HiDocumentReport
} from 'react-icons/hi'
import {
  ButtonCreateInterface
} from '../ButtonCreate'
interface ButtonExportInterface extends ButtonCreateInterface {
  exportType: 'excel' | 'pdf'
}

export const ButtonExport: React.FC <ButtonExportInterface> = ({
  text,
  noText = false,
  variant,
  tooltip = true,
  tooltipText,
  tooltipPlacement,
  size = "sm",
  exportType = 'excel',
  ...rest
}) => {
  return (
    <OverlayTrigger
      placement={tooltipPlacement}
      overlay={tooltip ? <Tooltip>{tooltipText ?? 'Export data'}</Tooltip> : <div></div>}
    >
      <Button
        {...rest}
        size={size === "sm" ? "sm" : size === "lg" ? "lg" : undefined}
        variant={variant ?? exportType === 'pdf' ? "outline-danger" : "outline-success"}
      >
        <div className="d-flex justify-content-center align-items-center">
          <div>
            {exportType === 'pdf'
              ? <HiDocument className="mb-1" />
              : <HiDocumentReport className="mb-1" />
            }
          </div>
          {!noText && (
            <span className="mx-1 text-uppercase">
              {text  ? text : exportType === "pdf" ? "Export PDF" : "Export Excel"}
            </span>
          )}
        </div>
      </Button>
    </OverlayTrigger>
  )
}